import { v4 as uuidv4 } from 'uuid'

export function guid(): string {
    return uuidv4()
}